import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { jstToday } from "../lib/jst";

export const PromoBanners = ({ channel }) => {
  const { t, lang } = useI18n();
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      const today = jstToday();
      setBanners(
        (data.banners || []).filter(
          (b) =>
            b.active !== false &&
            b.channel === channel &&
            (!b.start_date || b.start_date <= today) &&
            (!b.end_date || b.end_date >= today)
        )
      );
    });
  }, [channel]);

  useEffect(() => {
    if (banners.length < 2) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % banners.length), 6000);
    return () => clearInterval(id);
  }, [banners.length]);

  if (banners.length === 0) return null;
  const b = banners[Math.min(idx, banners.length - 1)];
  const bTitle = (lang === "ja" && b.title_ja) || b.title;
  const bText = (lang === "ja" && b.text_ja) || b.text;
  const go = () => {
    const path = b.channel === "resto" ? "/resto" : "/toko";
    navigate(b.category ? `${path}?cat=${encodeURIComponent(b.category)}` : path);
  };

  return (
    <div className="space-y-2" data-testid="promo-banners">
      <button
        onClick={go}
        data-testid={`promo-banner-${b.category || "all"}`}
        className="group relative block w-full overflow-hidden rounded-2xl text-left h-44 sm:h-60 lg:h-72 bg-gray-900"
      >
        {b.image_url && (
          <img
            src={b.image_url}
            alt={bTitle}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/45 to-transparent" />
        <div className="relative h-full flex flex-col justify-end p-5 sm:p-7 text-white">
          <p className="font-display text-2xl sm:text-3xl font-semibold leading-tight">
            {bTitle}
          </p>
          {bText && <p className="text-sm text-white/80 mt-1 max-w-md">{bText}</p>}
          <span className="mt-3 inline-flex w-fit items-center rounded-full bg-white text-gray-900 px-4 py-1.5 text-sm font-medium">
            {b.category ? `${t("shop_now")} · ${b.category}` : t("shop_now")}
          </span>
        </div>
      </button>
      {banners.length > 1 && (
        <div className="flex gap-1.5 justify-center">
          {banners.map((b, i) => (
            <button
              key={`dot-${b.title}-${i}`}
              data-testid={`banner-dot-${i}`}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                i === idx ? "w-6 bg-gray-900" : "w-1.5 bg-gray-300"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
